
document.addEventListener("DOMContentLoaded", () => {
    const
    cookiesBtns = document.querySelectorAll(".cky-btn"),
    copy = document.getElementById("copy");

    function copyToClipboard(text) {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(function() {
            alert('Lien copié dans le presse-papier !');
          }, function(err) {
            alert('Erreur lors de la copie : ' + err);
          });
        } else {
          // Fallback pour les navigateurs qui ne supportent pas l'API Clipboard
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          try {
            document.execCommand('copy');
            alert('Lien copié dans le presse-papier !');
          } catch (err) {
            alert('Erreur lors de la copie : ' + err);
          }
          document.body.removeChild(textarea);
        }
    }

    copy.addEventListener("click",() => {
        copyToClipboard();
    });

    function getCookie(name) {
      let cookies = document.cookie.split('; ');
      for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i].split('=');
          if (cookie[0] === name) {
              return decodeURIComponent(cookie[1]);
          }
      }
      return null;
    }

  // Vérifier le consentement "functional"
  function checkFunctionalConsent() {
      let consentCookie = getCookie('cookieyes-consent');
      if (!consentCookie) return false; // Pas de cookie → Considéré comme refusé

      let consentPairs = consentCookie.split(',');
      let consentValues = {};
      
      // Convertir le cookie en objet clé:valeur
      consentPairs.forEach(pair => {
          let [key, value] = pair.split(':');
          consentValues[key] = value;
      });

      return consentValues['functional'] === 'yes'; // Retourne true si accepté
  }

  // Gérer l'affichage des vidéos YouTube
  function handleYouTubeDisplay() {
      let iframes = document.querySelectorAll("iframe");

      if (iframes.length === 0) return; // Pas de vidéo, on ne fait rien

      if (!checkFunctionalConsent()) {
          iframes.forEach(iframe => {
              let placeholder = document.createElement("div");
              placeholder.innerHTML = "<p>Le contenu YouTube est bloqué car vous avez refusé les cookies.</p>";
              iframe.parentNode.replaceChild(placeholder, iframe);
          });
      }
  }

  // Exécuter la vérification
  handleYouTubeDisplay();

  if(cookiesBtns.length != 0){
    cookiesBtns.forEach(btn => {
        btn.addEventListener("click", () => handleInstaDisplay())
    })
}
})